// @flow
import * as React from 'react';

import { useLocation, matchPath } from 'react-router-dom';
import { customPendo } from 'common/utils/Pendo';
import * as qs from 'query-string';
import moment from 'moment-timezone';

const DataDateRangeTracker = (): React.Node => {
    const location = useLocation();

    React.useEffect(() => {
        // track Insights
        const isInsights = matchPath(location.pathname, {
            path: '/client/:clientId/insights',
            exact: false
        });

        if (isInsights) {
            const { startDate, endDate } = qs.parse(location.search);
            // NOTE: intentionally not handling date range case, as it is max last 30 days and
            // we are more interested in past date ranges (like 6 months year last year etc)
            if (startDate && endDate) {
                customPendo.trackDataDateRange({
                    startDate,
                    endDate,
                    source: 'insights'
                });
            }
            return;
        }

        // track dispatcher
        const isDispatcher = matchPath(location.pathname, {
            path: '/client/:clientId/batch',
            exact: false
        });
        if (isDispatcher) {
            const { week, month } = qs.parse(location.search);
            if (week) {
                customPendo.trackDataDateRange({
                    startDate: moment(week, 'DDMMMYYYY')
                        .startOf('week')
                        .format('DD-MM-YYYY'),
                    endDate: moment(week, 'DDMMMYYYY')
                        .endOf('week')
                        .format('DD-MM-YYYY'),
                    raw: week,
                    source: 'dispatcher'
                });
            } else if (month) {
                customPendo.trackDataDateRange({
                    startDate: moment(month, 'DDMMMYYYY')
                        .startOf('month')
                        .format('DD-MM-YYYY'),
                    endDate: moment(month, 'DDMMMYYYY')
                        .endOf('month')
                        .format('DD-MM-YYYY'),
                    raw: month,
                    source: 'dispatcher'
                });
            }
            return;
        }

        // track live_view
        const isLiveView = matchPath(location.pathname, {
            path: '/client/:clientId/live_view',
            exact: false
        });
        if (isLiveView) {
            const { date } = qs.parse(location.search);
            if (date) {
                customPendo.trackDataDateRange({
                    startDate: date,
                    endDate: date,
                    source: 'live_view'
                });
            }
            return;
        }
    }, [location]);

    return null;
};

export default DataDateRangeTracker;
